import { formatDate } from '@helpers/helper.novelty'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'

type Props = {
  hidenTags: boolean
  skeleton: boolean
  hidenAuthor?: boolean
  isHome: boolean
  novelty: Novelty
  tags: TagMediacore[]
  dispatch: any
  isSummaryCard: boolean
  placeholder?: string
  upperCaseLink?: boolean
  dateFormat?: 'long' | 'short'
  keyIndex?: number
}

const Novelty_Card_9 = (props: Props & RealEstateDataPageComponentData) => {
  const {
    novelty,
    skeleton,
    isSummaryCard,
    global_data: {
      divisionPath,
      content: {
        cardsNovelties: {
          data: { button },
        },
      },
    },
  } = props

  const dateFormat = props?.dateFormat
  const noveltyPath = novelty?.id
    ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}`
    : '/'

  return (
    <section
      id="novelty-card"
      className="novelty-card-9"
    >
      <Row>
        <span
          style={{ color: '#999999', fontWeight: '600' }}
          className={`date mb-3 ${skeleton ? 'd-none' : ''}`}
        >
          {formatDate(novelty?.date_published, dateFormat ? dateFormat : 'short')}
        </span>
      </Row>
      <Row className={`w-100 ${skeleton ? 'skeleton' : ''}`}>
        <img
          src={novelty?.image}
          alt=""
        />
      </Row>
      <Row
        className={`d-flex justify-content-between align-items-top w-100 mt-4 ${
          skeleton ? 'skeleton' : ''
        }`}
      >
        <Col
          xs={12}
          lg={isSummaryCard ? 12 : 7}
        >
          <ElementHTML
            children={novelty?.title}
            elementType="h4"
            className="text-sm-bold"
          />
          <ElementHTML
            children={novelty?.headline}
            elementType="p"
          />
        </Col>
        <Col
          className={` ${
            isSummaryCard ? 'text-start mt-3' : 'text-start text-lg-end mt-3 mt-lg-0'
          }`}
        >
          <Link
            to={noveltyPath}
            className={`btn btn-primary ${button?.border ? 'border' : ''}`}
          >
            {button?.value ?? 'Leer novedad'}
            {button?.image && (
              <img
                src={button?.image}
                className="button-logo"
              />
            )}
          </Link>
        </Col>
      </Row>
    </section>
  )
}

export default Novelty_Card_9
